module.exports = __webpack_public_path__ + "img/loading.c0938b90.svg";